import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.js';
import reportWebVitals from './reportWebVitals.js';
import { BrowserRouter } from 'react-router-dom';

async function prepare() {
  if (process.env.NODE_ENV === 'development') {
    try {
      const params = new URLSearchParams(window.location.search);
      const enable = params.get('mock') === '1';
      if (enable) {
        const { worker } = await import('./mocks/browser.js');
        await worker.start({ onUnhandledRequest: 'bypass' });
        // eslint-disable-next-line no-console
        console.log('[MSW] Mocking enabled');
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn('[MSW] Failed to start worker', e);
    }
  }
}

prepare().finally(() => {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
